import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Icons from "../../myIcon/Icons";
import { usePermissions } from "../../helper/PermissionContext";

// Each top-level sidebar module has its own API permission slug.
const MENU = {
  userManagement: "user-management",
  dashboard: "dashboard",
  blogManagement: "blog-management",
  globalSeo: "global-seo",
  seoManagement: "seo-management",
  sitemapManagement: "sitemap-management",
  llmsManagement: "llms-management",
  robotsManagement: "robots-management",
  emailManagement: "email-management",
  faqManagement: "faq-management",
  career: "career",
  jobApplications: "job-applications",
  caseStudy: "case-study",
  videos: "videos",
  infographic: "infographic",
  eguide: "eguide",
  whitepaper: "whitepaper",
  leadership: "leadership",
  newsletterPage: "newsletter-page",
  pressRelease: "press-release",
  contactUs: "contact-us",
  team: "team",
};

export default function SideBar({ isOpen, toggleSidebar }) {
  const [isUserManagementOpen, setIsUserManagementOpen] = useState(false);
  const [isBlogManagementOpen, setIsBlogManagementOpen] = useState(false);
  const [isCareerOpen, setIsCareerOpen] = useState(false);
  const { hasPermission } = usePermissions();
  const navigate = useNavigate();

  const toggleUserManagement = () => setIsUserManagementOpen((prev) => !prev);
  const toggleBlogManagement = () => setIsBlogManagementOpen((prev) => !prev);
  const toggleCareer = () => setIsCareerOpen((prev) => !prev);

  const handleLogout = () => {
    localStorage.removeItem("Token3gen");
    navigate("/login");
  };

  return (
    <>
      <div className={`admin-logo-wrap ${isOpen ? "close" : "open"}`}>
        <img src="/logo.webp" alt="logo" className="img-responsive" />
        <button className="toggle-button" onClick={toggleSidebar}>☰</button>
      </div>

      <div className={`admin-sidebar ${isOpen ? "close" : "open"}`}>
        <div className="scroller-sidebar">
          <ul style={isOpen
            ? { transition: "all 0.3s ease-in", opacity: "0", visibility: "hidden" }
            : { transition: "all 0.3s ease-in", opacity: "1", visibility: "visible" }}>

            {hasPermission(MENU.dashboard) && (
              <li>
                <Link to="/"><span><img src="/assets/dashboard.webp" alt="icon" className="img-responsive" />Dashboard</span></Link>
              </li>
            )}

            {hasPermission(MENU.userManagement) && (
              <li className={`innertab ${isUserManagementOpen ? "openlist" : ""}`} onClick={toggleUserManagement}>
                <div><span><img src="/assets/dashboard.webp" alt="icon" className="img-responsive" /> User Management</span> <Icons name="arrowDown" /></div>
                <ul className={`nested-list ${isUserManagementOpen ? "open" : "close"}`}>
                  <li><Link to="/users">Users</Link></li>
                  <li><Link to="/roles">Roles</Link></li>
                  <li><Link to="/permissions">Permissions</Link></li>
                </ul>
              </li>
            )}

            {hasPermission(MENU.blogManagement) && (
              <li className={`innertab ${isBlogManagementOpen ? "openlist" : ""}`} onClick={toggleBlogManagement}>
                <div><span><img src="/assets/blog-management.webp" alt="icon" className="img-responsive" /> Blog Management</span> <Icons name="arrowDown" /></div>
                <ul className={`nested-list ${isBlogManagementOpen ? "open" : "close"}`}>
                  <li><Link to="/blog">Blog</Link></li>
                  <li><Link to="/category">Category</Link></li>
                  <li><Link to="/author">Author</Link></li>
                  <li><Link to="/tag">Tag</Link></li>
                </ul>
              </li>
            )}

            {hasPermission(MENU.globalSeo) && (
              <li><Link to="/global-seo"><span><img src="/assets/seo-management.webp" alt="icon" className="img-responsive" />Global SEO</span></Link></li>
            )}

            {hasPermission(MENU.seoManagement) && (
              <li><Link to="/seo"><span><img src="/assets/seo-management.webp" alt="icon" className="img-responsive" />SEO Management</span></Link></li>
            )}

            {hasPermission(MENU.sitemapManagement) && (
              <li><Link to="/sitemap"><span><img src="/assets/seo-management.webp" alt="icon" className="img-responsive" />Sitemap Management</span></Link></li>
            )}

            {hasPermission(MENU.llmsManagement) && (
              <li><Link to="/llms-management"><span><img src="/assets/seo-management.webp" alt="icon" className="img-responsive" />LLMS Management</span></Link></li>
            )}

            {hasPermission(MENU.robotsManagement) && (
              <li><Link to="/robots"><span><img src="/assets/seo-management.webp" alt="icon" className="img-responsive" />Robots.txt Management</span></Link></li>
            )}

            {hasPermission(MENU.emailManagement) && (
              <li><Link to="/email-management"><span><img src="/assets/media-management.webp" alt="icon" className="img-responsive" />Email Management</span></Link></li>
            )}

            {hasPermission(MENU.faqManagement) && (
              <li><Link to="/faq"><span><img src="/assets/media-management.webp" alt="icon" className="img-responsive" />FAQ Management</span></Link></li>
            )}

            {hasPermission(MENU.career) && (
              <li className={`innertab ${isCareerOpen ? "openlist" : ""}`} onClick={toggleCareer}>
                <div><span><img src="/assets/blog-management.webp" alt="icon" className="img-responsive" /> Career</span> <Icons name="arrowDown" /></div>
                <ul className={`nested-list ${isCareerOpen ? "open" : "close"}`}>
                  <li><Link to="/jobpost">Job Post</Link></li>
                  <li><Link to="/location">Location</Link></li>
                  <li><Link to="/operation">Department</Link></li>
                  <li><Link to="/experience">Experience</Link></li>
                </ul>
              </li>
            )}

            {hasPermission(MENU.jobApplications) && (
              <li><Link to="/job-applications"><span><img src="/assets/contact-management.webp" alt="icon" className="img-responsive" />Job Applications</span></Link></li>
            )}

            {hasPermission(MENU.caseStudy) && (
              <li><Link to="/case"><span><img src="/assets/media-management.webp" alt="icon" className="img-responsive" />Case Study</span></Link></li>
            )}

            {hasPermission(MENU.videos) && (
              <li><Link to="/video"><span><img src="/assets/media-management.webp" alt="icon" className="img-responsive" />Videos</span></Link></li>
            )}

            {hasPermission(MENU.infographic) && (
              <li><Link to="/infographic"><span><img src="/assets/media-management.webp" alt="icon" className="img-responsive" />Infographic</span></Link></li>
            )}

            {hasPermission(MENU.eguide) && (
              <li><Link to="/eguide"><span><img src="/assets/media-management.webp" alt="icon" className="img-responsive" />E-Guide</span></Link></li>
            )}

            {hasPermission(MENU.whitepaper) && (
              <li><Link to="/whitepaper"><span><img src="/assets/media-management.webp" alt="icon" className="img-responsive" />Whitepaper</span></Link></li>
            )}

            {hasPermission(MENU.leadership) && (
              <li><Link to="/leadership"><span><img src="/assets/media-management.webp" alt="icon" className="img-responsive" />Leadership</span></Link></li>
            )}

            {hasPermission(MENU.newsletterPage) && (
              <li><Link to="/newsletter-page"><span><img src="/assets/media-management.webp" alt="icon" className="img-responsive" />Newsletter Page</span></Link></li>
            )}

            {hasPermission(MENU.pressRelease) && (
              <li><Link to="/press-release"><span><img src="/assets/media-management.webp" alt="icon" className="img-responsive" />Press Release</span></Link></li>
            )}

            {hasPermission(MENU.contactUs) && (
              <li><Link to="/contact"><span><img src="/assets/blog-management.webp" alt="icon" className="img-responsive" />Contact Us</span></Link></li>
            )}

            {hasPermission(MENU.team) && (
              <li><Link to="/teams"><span><img src="/assets/blog-management.webp" alt="icon" className="img-responsive" />Team</span></Link></li>
            )}
          </ul>
        </div>

        <button onClick={handleLogout} className="default-btn logout-button">Logout<span></span></button>
      </div>
    </>
  );
}
